export default {
    computed: {
        newsletterMailingData() {
            return this.$store.state.mailing.newsletterMailingData
        },

        newsletterMailingIsLoaded() {
            return this.$store.state.mailing.newsletterMailingIsLoaded
        },

        subscriberToken: {
            get: function () {
                return this.$store.state.mailing.subscriberToken
            },
            set: function (value) {
                this.$store.commit('mailing/setSubscriberToken', value)
            }
        },
    },

    methods: {
        /////////////////////////////////////////////////
        //Actions
        /////////////////////////////////////////////////
        fetchNewsletterMailingData(newsletterMailingId) {
            return this.$store.dispatch('mailing/fetchNewsletterMailingData', {newsletterMailingId})
        }
    }
}
